import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { EventScoreboard, FootballScore, PenaltyStatus, TeamShootout } from '@frontend/sports/betting-offer/feature/model';
import { ceil, times, values } from 'lodash-es';

@Component({
    selector: 'ms-penalty-shootout',
    templateUrl: './penalty-shootout.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PenaltyShootoutComponent {
    @Input() scoreboard: EventScoreboard;
    @HostBinding('class') className = 'penalty-shootout';

    get penalties(): TeamShootout[] {
        return this.getPenalties();
    }

    get score(): number[] {
        const penaltyScore = this.getPenalties();

        return [
            penaltyScore[0].penalties.filter((status) => status === PenaltyStatus.Scored).length,
            penaltyScore[1].penalties.filter((status) => status === PenaltyStatus.Scored).length,
        ];
    }

    private getPenalties(): TeamShootout[] {
        const score = this.scoreboard.score as FootballScore;
        const visible = 5;
        if (score && score.penaltyShootOutScore !== undefined) {
            const teams = values(score.penaltyShootOutScore);
            const offset = ceil(teams[0].length / visible - 1) * visible;

            return teams.map((team, i) => ({
                points: team.filter((penalty) => penalty.status === PenaltyStatus.Scored).length,
                penalties: times(visible).map((_penalty, index) => (team[index + offset] ? team[index + offset].status : PenaltyStatus.Unset)),
            }));
        }

        return [];
    }
}
